"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _BackgroundImage = _interopRequireDefault(require("./BackgroundImage"));
var _default = function _default(_ref) {
  var imageGroup = _ref.imageGroup,
    imageWidth = _ref.imageWidth;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    columns: imageGroup.length,
    style: {
      padding: '0'
    }
  }, imageGroup.map(function (image) {
    return /*#__PURE__*/_react["default"].createElement(_BackgroundImage["default"], {
      imageWidth: imageWidth,
      key: image,
      image: image
    });
  }));
};
exports["default"] = _default;